import React, { useEffect, useState } from "react";
import "jsvectormap/dist/maps/world.js";
import "jsvectormap/dist/css/jsvectormap.min.css";
import {
  Card,
  CardBody,
  CardExpandToggler,
} from "./../components/card/card.jsx";
import PerfectScrollbar from "react-perfect-scrollbar";
import Chart from "react-apexcharts";
import DateTime from "react-datetime";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../components/ButtonComponent.jsx";
import { CardHeader } from "react-bootstrap";
import DatatableComponent from "../components/DatatableComponent.jsx";
import { openForm } from "../redux/slice/userSlice.js";
import FormUser from "../form-data-master/FormUser.jsx";
import FormEditUser from "../form-data-master/FormEditUser.jsx";
import { useLocation } from "react-router-dom";
import { getRoleModuleById } from "../redux/action/roleModuleAction.js";
import findItem from "../helperFindPath.js";
import { getUserDetailPage, resetPassword } from "../redux/action/userDetailAction.js";
import { openDetail, openFormDelete, openFormEdit } from "../redux/slice/userDetailSlice.js";
import FormDetailUser from "../form-data-master/FormDetailUser.jsx";
import FormDeleteuser from "../form-data-master/FormDeleteuser.jsx";

function UserManagment() {
  const { dataUser, isOpenUser, isLoading, idUser } = useSelector( (state) => state.user );
  const { dataUserDetail, state } = useSelector( (state) => state.userDetail );
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [page, setPage] = useState(0)
  const [sort, setSort] = useState('')
  const [select, setSelect] = useState('')
  const [filter, setFilter] = useState('')
  const countPerPage = 10
  const param = {
    token: user.access_token,
    sort: sort,
    size: countPerPage,
    select: select,
    filter: filter,
    page: page,
  }
  const dialogAlert = (token, username) => {
    let answer = window.confirm('Yakin Reset Password dengan username : ' + username)
    if (answer) {
      // Save it!
      param.data = { username: username }
      dispatch(resetPassword(param))
    } else {
      // Do nothing!
      alert('Batal Reset Password')
    }
  }
  const columns = [
      {
        name: 'Nama Pengguna',
        selector: (row) => row.username,
        sortable: true,
      },
      {
        name: 'Nama Peran',
        selector: (row) => row.rolesName,
        sortable: true,
      },
      {
        name: 'Action',
        cell: (row) => (
          <div style={{ padding: '10px 0' }}>
            <ButtonComponent
              onClick={(e) => dispatch(openDetail({ open: true, id: row.id, data: row }))}
              color="#fff"
                backgroundColor="#3c484f"
                backgroundHover="#db4912"
                style={{ marginRight: 5 }}
            >
              <i className="fas fa-eye" title="Lihat Detail Pengguna"/>
            </ButtonComponent>
          {dataByIdRoleModule !== '' ? dataByIdRoleModule.update ? (
            <ButtonComponent
              onClick={(e) =>
                  dispatch(openFormEdit({ state: 'editDetail', open: true, id: row.id, data: row }))
              }
              color="#fff"
              backgroundColor="#3c484f"
              backgroundHover="#db4912"
              style={{ marginRight: 5 }}
              >
              <i className="fas fa-pencil-alt" title='Ubah Data Pengguna' style={{ paddingRight: '5px'}}/> 
            </ButtonComponent>
            ): null : null}
            {dataByIdRoleModule !== '' ? dataByIdRoleModule.delete ? (
            <ButtonComponent
              onClick={(e) =>
                  dispatch(openFormDelete({ state: 'delete', open: true, id: row.id, data: row }))
              }
              color="#fff"
              backgroundColor="#3c484f"
              backgroundHover="#db4912"
              style={{ marginRight: 5 }}
              >
              <i className="fas fa-trash" title='Hapus Data Pengguna' />
            </ButtonComponent>
            ): null : null }
            <ButtonComponent
              onClick={() => dialogAlert(user.access_token, row.username)}
              color="#fff"
              backgroundColor="#3c484f"
              backgroundHover="#db4912"
              >
              <i className="fas fa-undo" title='Reset Password User' />
            </ButtonComponent>  
          </div>
        ),
      },
    ]

  useEffect(() => {
    dispatch(getUserDetailPage(param));
    // eslint-disable-next-line
  }, []);
  const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
  const { pathname } = useLocation();
  const [ dataObjPath, setDataObjPath] = useState('')
  useEffect(() => {
    if(dataObjPath !== ''){
      param.id = dataObjPath.id
      dispatch(getRoleModuleById(param))
    }
    // eslint-disable-next-line
  }, [dataObjPath]);
  useEffect(()=>{
    if(dataRoleModuleSidebar.length > 0){
      const findPath = findItem(dataRoleModuleSidebar, pathname)
      if(findPath !== null){
        setDataObjPath(findPath) 
      }
    }
  },[dataRoleModuleSidebar])

  // if(dataByIdRoleModule !== ''){

  //   if(!dataByIdRoleModule.create && !dataByIdRoleModule.read && !dataByIdRoleModule.update && !dataByIdRoleModule.delete){
  //     return (
  //       <div>
  //         <h2>403: Forbidden</h2>
  //         <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
  //       </div>
  //     )
  //   }else{


  return (
    <div>
      <h4>Daftar Pengguna</h4>
      <div className="row">
        <div className="col-xl-12">
          <Card className="mb-3"> 
          <CardHeader style={{ borderBottom: "none" }}>
              <div className="row">
                <div className="col-xl-6">
                  <span style={{ fontSize: "1rem" }}> Pengguna </span>
                  <span className="text-secondary"> List </span>
                </div>
                <div
                  className="col-xl-6"
                  style={{ textAlign: "right", alignSelf: "center" }}
                >

                {dataByIdRoleModule.create ? (
                  <ButtonComponent
                    onClick={() =>
                      dispatch(openForm({ open: true, state: "add" }))
                    }
                    color="white"
                    backgroundColor="#3003fc"
                    backgroundHover="#2404b5"
                  >
                    + Tambah
                  </ButtonComponent>
                  ) :null }
                </div>
              </div>
            </CardHeader>
            <CardBody>
            <DatatableComponent
                data={dataUserDetail}
                page={page}
                countPerPage={countPerPage}
                columns={columns}
                setPage={setPage}
              />
            </CardBody>
          </Card>
        </div>
      </div>
      <FormUser param={param} />
      <FormDetailUser param={param} />
      <FormEditUser param={param} />
      <FormDeleteuser param={param} />
      
    </div>
  );
  // }
  // }
  //   return (
  //   <div>
  //     <h2>403: Forbidden</h2>
  //     <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
  //   </div>
  // )
}

export default UserManagment;
